import script from "./SettingsNavMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsNavMenu.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__